import { render, staticRenderFns } from "./PersonaFisica.vue?vue&type=template&id=186df53b"
import script from "./PersonaFisica.vue?vue&type=script&lang=js"
export * from "./PersonaFisica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports